(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["abide-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abide-delivery')) {
    customElements.define('abide-delivery', class extends HTMLElement {
      connectedCallback() {
        const date = new Date();
        date.setDate(date.getDate() + [1,1,1,1,1,3,2][date.getDay()]);
        const target = this.querySelector('[data-delivery-date]');
        if (target) target.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {weekday:'short', month:'short', day:'numeric'}).format(date);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
